import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SeoJsonLd from "@/components/base/SeoJsonLd";
import { faqItems } from "@/mocks/basetaoData";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ContentSections from "./components/ContentSections";
import ReviewSection from "./components/ReviewSection";
import BlogPreviewSection from "./components/BlogPreviewSection";
import FAQSection from "./components/FAQSection";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://basetaosheet.surf";
const FAVICON_URL = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png";

export default function Home() {
  return (
    <>
      <SeoJsonLd
        type="Multi"
        items={[
          {
            type: "WebSite",
            data: {
              url: SITE_URL,
              name: "BaseTao Spreadsheet",
              description: "The ultimate BaseTao Spreadsheet resource hub covering product guides, shipping cost analysis, warehouse tips, reviews, coupons, and expert buying strategies.",
              searchUrl: `${SITE_URL}/?search={search_term_string}`,
            },
          },
          {
            type: "Organization",
            data: {
              url: SITE_URL,
              name: "BaseTao Spreadsheet",
              description: "Independent BaseTao Spreadsheet resource providing guides, reviews, shipping analysis, and buyer education for smarter shopping decisions.",
              logoUrl: FAVICON_URL,
            },
          },
          {
            type: "BreadcrumbList",
            data: {
              items: [
                { name: "Home", url: SITE_URL },
              ],
            },
          },
          {
            type: "FAQPage",
            data: {
              questions: faqItems.map((item) => ({
                question: item.question,
                answer: item.answer,
              })),
            },
          },
        ]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ContentSections />
        <ReviewSection />
        <BlogPreviewSection />
        <FAQSection />
        <section className="w-full py-12 bg-background-100">
          <div className="w-full px-4 md:px-6 lg:px-10 text-center">
            <div className="max-w-2xl mx-auto">
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-4">
                Ready to Start Shopping Smarter?
              </h2>
              <p className="text-sm md:text-base text-foreground-600 mb-6">
                Visit our main website to explore thousands of products with the power of BaseTao Spreadsheet.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  BaseTao Spreadsheet
                  <i className="ri-arrow-right-up-line ml-2 w-4 h-4 flex items-center justify-center"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  Buy It Now
                  <i className="ri-shopping-cart-line ml-2 w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}